import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-30 text-3xl text-gray-600 capitalize animate-pulse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-element fixed top-0 left-0 z-10 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out", { 'opacity-0': _ctx.loaded, 'opacity-100': !_ctx.loaded, hidden: _ctx.hidden }])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute top-0 left-0 z-20 h-full w-full bg-nucleus-lightestBlue opacity-80" }, null, -1)),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.message), 1)
  ], 2))
}